import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ef6b5c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1 text-primary border border-primary px-3 py-1 rounded" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-6 me-4"
}
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = {
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_10 = { class: "card-body pt-2 pb-3" }
const _hoisted_11 = {
  key: 0,
  class: "card-body pt-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-header" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_16 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "row align-items-center"
}
const _hoisted_18 = { class: "col-5 item-chart" }
const _hoisted_19 = { class: "text-center mb-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mb-1" }, "Ads Packages", -1))
const _hoisted_21 = { class: "fs-2 fw-boldest text-dark" }
const _hoisted_22 = { class: "chart-container position-relative" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-center-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-dark" }, "Packages"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, "Details")
], -1))
const _hoisted_24 = { class: "col-7 ps-3" }
const _hoisted_25 = { class: "symbol symbol-12px me-2" }
const _hoisted_26 = { class: "flex-grow-1" }
const _hoisted_27 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_28 = { class: "flex-grow-1" }
const _hoisted_29 = { class: "fs-6 fw-bold text-dark mb-1" }
const _hoisted_30 = { class: "row p-0 m-0" }
const _hoisted_31 = { class: "col-6 pe-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mb-0" }, "Subscriptions:", -1))
const _hoisted_33 = { class: "fs-7 fw-bold text-dark" }
const _hoisted_34 = { class: "col-6 ps-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mb-0" }, "Revenues:", -1))
const _hoisted_36 = { class: "fs-7 fw-bold text-dark" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 1,
  class: "ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.translate('brokerAdsPackagesReport')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedPeriod === 'custom')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(`${_ctx.customDateFrom} till ${_ctx.customDateTo}`), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.selectedPeriod), 1),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectPeriod('yesterday')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('yesterday')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-7-days' }]),
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-7-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last7Days')), 3)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-30-days' }]),
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-30-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last30Days')), 3)
            ]),
            _hoisted_9,
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'custom' }]),
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showCustomDatePicker()), ["prevent"]))
              }, _toDisplayString(_ctx.translate('customRange')), 3)
            ])
          ])
        ]),
        _createVNode(_component_CustomDatePicker, {
          show: _ctx.showDatePicker,
          dateFrom: _ctx.customDateFrom,
          "onUpdate:dateFrom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customDateFrom) = $event)),
          dateTo: _ctx.customDateTo,
          "onUpdate:dateTo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customDateTo) = $event)),
          onApply: _ctx.applyCustomDates,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDatePicker = false))
        }, null, 8, ["show", "dateFrom", "dateTo", "onApply"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_16))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.total?.revenues), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_apexchart, {
                  type: "donut",
                  options: _ctx.chartOptions,
                  series: _ctx.chartSeries,
                  height: "160"
                }, null, 8, ["options", "series"]),
                _hoisted_23
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex align-items-center mb-2 info-content",
                  key: item.packageType
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["symbol-label rounded-circle", _ctx.getClassBg(item.packageType)])
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(item.title), 1),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, _toDisplayString(item.count), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("div", _hoisted_36, _toDisplayString(item.revenues) + " KWD ", 1)
                          ])
                        ])
                      ]),
                      (item.revenuesChangePercentage !== 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fs-8 fw-bold d-flex align-items-center ms-2",
                            style: _normalizeStyle({ color: _ctx.textColor(item.revenuesChangePercentage) })
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.pct(item.revenuesChangePercentage)) + "% ", 1),
                            (_ctx.arrowSrc(item.revenuesChangePercentage))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.arrowSrc(item.revenuesChangePercentage) || undefined,
                                  alt: "trend",
                                  class: "ms-1",
                                  style: {"width":"10px","height":"10px"}
                                }, null, 8, _hoisted_37))
                              : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.arrow(item.revenuesChangePercentage)), 1))
                          ], 4))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}